import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=0090c9b2&scoped=true"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"
import style0 from "./Questions.vue?vue&type=style&index=0&id=0090c9b2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0090c9b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0090c9b2')) {
      api.createRecord('0090c9b2', component.options)
    } else {
      api.reload('0090c9b2', component.options)
    }
    module.hot.accept("./Questions.vue?vue&type=template&id=0090c9b2&scoped=true", function () {
      api.rerender('0090c9b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/rubricSetting/Add/components/Questions.vue"
export default component.exports